import React from 'react';
import { connect } from 'react-redux';
import { Dispatch, Action } from 'redux';
import styled from 'styled-components';
import { forDesktop, forIE } from '@westwing/ui-kit/breakPoints';
import { CategoryData } from '../../../redux/category/types';
import useTranslator from '../../../hooks/useTranslator';
import viewport from '../../../../common/helpers/viewport';
import { hideOverlay } from '../../../redux/overlays/actions';
import StateInterface from '../../../redux/types';
import CategoryNavItem from './CategoryNavItem';

export const StyledCategoryNavContainer = styled.nav`
    padding: 10px 30px;
    ${forDesktop`
        padding: 32px 0;
        position: sticky;
    `}
    ${forIE`
        padding-top: 20px; 
    `}
`;

interface Props {
    isDesktopView?: boolean;
    hideLastItemBorder?: boolean;
    categories: CategoryData[];
    hideNavigationFlyout?: Function;
}

export const renderCategoryItems = (
    categories: CategoryData[],
    closeFunction: (id: string) => void,
    t: Function,
    hideLastItemBorder?: boolean,
    isDesktopView?: boolean
    // eslint-disable-next-line max-params
): React.ReactElement => {
    return (
        <>
            {categories.map((category: CategoryData) => (
                <CategoryNavItem
                    key={category.url}
                    dismissNavigationFlyOut={closeFunction}
                    category={category}
                    t={t}
                    isRoot
                    hideLastItemBorder={hideLastItemBorder}
                    isDesktopView={isDesktopView}
                />
            ))}
        </>
    );
};

const CategoryListing: React.FC<Props> = ({
    categories,
    hideNavigationFlyout = () => {},
    isDesktopView,
    hideLastItemBorder,
}): React.ReactElement => {
    const t = useTranslator();

    const closeOverlayAndScrollToTop = (id: string): void => {
        viewport.scrollToTop();
        hideNavigationFlyout(id);
    };

    return (
        <>
            <ul>{renderCategoryItems(categories, closeOverlayAndScrollToTop, t, hideLastItemBorder, isDesktopView)}</ul>
        </>
    );
};

const mapStateToProps = (state: StateInterface): { categories: CategoryData[] } => {
    const categories = state.categories.originalCategories;
    return { categories };
};

const mapDispatchToProps = (dispatch: Dispatch): {} => ({
    hideNavigationFlyout: (id: string): Action => dispatch(hideOverlay(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryListing);
